import React, { useState } from 'react'
import { useTranslation } from '../../../context/translationProvider'
import { useEventTracking } from '../../../context/eventTrackingProvider'
import { 
  INGAME_CTA_ACTIONS,
  INGAME_DRAWERS,
} from '../../../utils/constants'
import {
  QuitGameConfirmationCheckboxWrapper,
  QuitGameConfirmationContainer,
  QuitGameConfirmationImage,
  QuitGameConfirmationTitle,
} from './styles'
import { Text } from '../../atoms/text'
import { Checkbox } from '../../atoms/checkbox'
import { Button } from '../../atoms/button'
import storageService from '../../../services/storageService'

import QuitConfirmationIcon from '../../../images/quit_icon.svg'

export const QuitGameConfirmation = ({
  handleLeaveAction,
  handleCloseDrawer,
}) => {
  const [doNotOpenQuitConfimation, setDoNotOpenQuitConfirmation] = useState()
  const { translate } = useTranslation()
  const { trackEvent, EVENT_NAMES } = useEventTracking()

  const handleQuitConfimrationSettingChange = ({ target: { checked } }) => {
    setDoNotOpenQuitConfirmation(checked)
    
    trackEvent(EVENT_NAMES.INGAME_ACTION_TAKEN, {
      drawer: INGAME_DRAWERS.EXIT,
      cta: INGAME_CTA_ACTIONS.DONT_SHOW_AGAIN_SELECT,
      value: checked,
    }, true)
  }

  const handleQuitConfirmationStayAction = () => {
    handleCloseDrawer()
    trackEvent(EVENT_NAMES.INGAME_ACTION_TAKEN, {
      drawer: INGAME_DRAWERS.EXIT,
      cta: INGAME_CTA_ACTIONS.STAY,
    }, true)
    storageService.setValue(
      'gameCloseConfirmationDoNotShow',
      doNotOpenQuitConfimation
    )
  }

  const handleQuitConfirmationLeaveAction = () => {
    trackEvent(EVENT_NAMES.INGAME_ACTION_TAKEN, {
      drawer: INGAME_DRAWERS.EXIT,
      cta: INGAME_CTA_ACTIONS.CONFIRM_EXIT,
    }, true)
    
    storageService.setValue(
      'gameCloseConfirmationDoNotShow',
      doNotOpenQuitConfimation
    )
    handleLeaveAction()
  }

  return (
    <QuitGameConfirmationContainer>
      <QuitGameConfirmationTitle>
        {translate('game.exit-game.heading')}
      </QuitGameConfirmationTitle>
      <QuitGameConfirmationImage
        src={QuitConfirmationIcon}
      />
      <Text>{translate('game.exit-game.paragraph')}</Text>
      <QuitGameConfirmationCheckboxWrapper>
        <Checkbox
          onChange={handleQuitConfimrationSettingChange}
          checked={doNotOpenQuitConfimation}
        >
          {translate('game.exit-game.dont-show')}
        </Checkbox>
      </QuitGameConfirmationCheckboxWrapper>
      <Button onClick={handleQuitConfirmationStayAction}>
        {translate('game.exit-game.button-primary')}
      </Button>
      <Button bordered dark onClick={handleQuitConfirmationLeaveAction}>
        {translate('game.exit-game.button-secondary')}
      </Button>
    </QuitGameConfirmationContainer>
  )
}
